module.exports = __webpack_public_path__ + "static/media/pd.d95c65c6.svg";